import React from 'react';

const TrainingApproach = () => {
  const approaches = [
    {
      title: "Hands-on, Real-world Case Studies",
      description: "Learn through actual industry scenarios and challenges our team has encountered and solved",
      icon: "fas fa-hand-paper",
      features: [
        "Actual project examples",
        "Problem-solving exercises",
        "Interactive workshops",
        "Group discussions"
      ]
    },
    {
      title: "Led by Certified Safety Professionals",
      description: "Our instructors are TÜV-certified engineers with extensive field experience",
      icon: "fas fa-user-tie",
      features: [
        "15+ years industry experience",
        "Current project involvement",
        "International expertise",
        "Practical insights"
      ]
    },
    {
      title: "Tailored for Facility Operations Teams",
      description: "Customized training programs that address your specific facility needs and challenges",
      icon: "fas fa-users-cog",
      features: [
        "Role-specific modules",
        "Industry-focused content",
        "Flexible scheduling",
        "On-site options available"
      ]
    }
  ];

  return (
    <section className="min-h-screen flex items-center py-20 px-4 sm:px-6 lg:px-8 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto w-full">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Training Approach</h2>
          <p className="text-xl text-gray-300">Excellence through experience and engagement</p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
          {approaches.map((approach, index) => (
            <div key={index} className="bg-gray-800 p-8 rounded-lg hover:bg-gray-700 transition-colors">
              <i className={`${approach.icon} text-5xl text-blue-400 mb-6 block`}></i>
              <h3 className="text-xl font-bold mb-3">{approach.title}</h3>
              <p className="text-gray-300 mb-6">{approach.description}</p>
              <ul className="space-y-2">
                {approach.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-gray-300">
                    <i className="fas fa-chevron-right text-blue-400 mr-2 text-sm"></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        
        <div className="bg-gradient-to-r from-blue-600 to-blue-800 p-12 rounded-lg">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-3xl font-bold mb-6">Why Our Training Makes a Difference</h3>
            <p className="text-xl leading-relaxed mb-8">
              We don't just teach theory – we share practical knowledge gained from implementing 
              functional safety systems in facilities worldwide. Our training bridges the gap 
              between standards and real-world application.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div>
                <div className="text-5xl font-bold mb-2">95%</div>
                <p className="text-lg">Participant Satisfaction</p>
              </div>
              <div>
                <div className="text-5xl font-bold mb-2">1000+</div>
                <p className="text-lg">Professionals Trained</p>
              </div>
              <div>
                <div className="text-5xl font-bold mb-2">50+</div>
                <p className="text-lg">Corporate Clients</p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-12 relative">
          <img
            src="/assets/asset-9.jpg"
            alt="Modern training room"
            className="w-full rounded-lg shadow-2xl opacity-80"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-gray-900/60 to-transparent rounded-lg"></div>
        </div>
      </div>
    </section>
  );
};

export default TrainingApproach;
